enum GradientDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'RIGHT',
}

export default GradientDirection;
